import { render, staticRenderFns } from "./PieLegend.vue?vue&type=template&id=626541b2&"
import script from "./PieLegend.vue?vue&type=script&lang=js&"
export * from "./PieLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports